import { PaginationItem as MuiPaginationItem } from '@mui/material';
import IcChevronLeftLargeRegular from '@kep/kcds-icons/IcChevronLeftLargeRegular';
import IcChevronRightLargeRegular from '@kep/kcds-icons/IcChevronRightLargeRegular';
import IcChevronsLeftLargeRegular from '@kep/kcds-icons/IcChevronsLeftLargeRegular';
import IcChevronsRightLargeRegular from '@kep/kcds-icons/IcChevronsRightLargeRegular';
import IcMoreHorizontalRegular from '@kep/kcds-icons/IcMoreHorizontalRegular';

import type { PaginationItemProps } from './types';

const PaginationItemComponentMap: PaginationItemProps['slots'] = {
  first: IcChevronsLeftLargeRegular,
  last: IcChevronsRightLargeRegular,
  previous: IcChevronLeftLargeRegular,
  next: IcChevronRightLargeRegular,
};

const PaginationItem = (props: PaginationItemProps) => {
  const { type, page, onClick, ...others } = props;

  if (type === 'end-ellipsis' || type === 'start-ellipsis') {
    return (
      <MuiPaginationItem
        {...others}
        sx={{ cursor: 'default', ['& svg']: { width: '16px', height: '16px', fontSize: '16px' } }}
        component={'div'}
        page={<IcMoreHorizontalRegular />}
        shape="rounded"
        variant="text"
      />
    );
  }

  return (
    <MuiPaginationItem
      type={type}
      page={page}
      shape="rounded"
      variant="text"
      slots={PaginationItemComponentMap}
      onClick={onClick}
      {...others}
    />
  );
};

export default PaginationItem;
